import { render, staticRenderFns } from "./admonition-component.vue?vue&type=template&id=ed9877b6&scoped=true&"
import script from "./admonition-component.vue?vue&type=script&lang=ts&"
export * from "./admonition-component.vue?vue&type=script&lang=ts&"
import style0 from "./admonition-component.vue?vue&type=style&index=0&id=ed9877b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9877b6",
  null
  
)

export default component.exports